module.exports = __webpack_public_path__ + "img/matrix-integrations-fr-ca.335ba7bb.jpg";